import { Container, Button, Form, Alert, Modal, Table } from 'react-bootstrap';
import { Sida, Rubrik, ContentWrapper } from "../ContentStyles";
import { FaBarcode, FaTrash } from 'react-icons/fa';
import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import MaterialReactTable from 'material-react-table';
import useBackend, { SpinnerX, Loading } from '../../services/useBackend_v2';
import { Branding } from '../../services/misc';

export default function Products() {
    const { loading, data, Refresh, resultVisible, Check, XCall, Update } = useBackend('/api/admin/products');
    const { loading: registerDataLoading, data: registerData } = useBackend(process.env.PUBLIC_URL + '/api/admin/Register');

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    var pageIndex = parseInt(searchParams.get('pageindex'), 10) || 0;
    var pageSize = parseInt(searchParams.get('pagesize'), 10) || 25;
    const [pagination, setPagination] = useState({ pageIndex: pageIndex, pageSize: pageSize });

    const [editProductModalshow, setEditProductModalshow] = useState(false);
    const [editProductGuid, setEditProductGuid] = useState(null);

    const editProductHandler = (event, rowData) => {
        event.preventDefault();
        setEditProductGuid(rowData.original.Guid)
        setEditProductModalshow(!editProductModalshow);        
    }

    async function addProductHandler(event) {
        event.preventDefault();
        await setEditProductGuid("00000000-0000-0000-0000-000000000000");
        setEditProductModalshow(!editProductModalshow);
    }

    async function closeAndRefresh() {
        setEditProductModalshow(false);
        Refresh();
    }

    const columns = useMemo(() => [
        { size: 40, accessorKey: 'EAN', header: 'EAN', enableColumnActions: false },
        { size: 40, accessorKey: 'Name', header: 'Name' },
        { size: 40, accessorKey: 'ProductGroup.Name', header: 'Produktgrupp' },

        {
            size: 20, header: 'Pris', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<>{row.original.Price.toFixed(2)}</>),
        },

        {
            size: 20, header: 'Manuell registrering', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.AllowManualRegistration} />),
        },

        {
            size: 20, header: 'Visa på prislista', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.ShowOnPricelist} />),
        },
    ]
    );

    const initialState = { density: 'compact', columnVisibility: { 'Manuell registrering': false, 'Visa på prislista': false, 'Price': false }, pagination: pagination };

    const state = { pagination: pagination };

    if (!loading && !registerDataLoading) {
        return (
            <ContentWrapper> 
                <ModalProductEdit   show={editProductModalshow} onHide={closeAndRefresh} editProductGuid={editProductGuid} registerData={registerData} ></ModalProductEdit>
                <Container>
                    <Sida>
                        <MaterialReactTable columns={columns} data={data.Products} onPaginationChange={setPagination} state={state} initialState={initialState}
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false, labelRowsPerPage: "Rader" }}
                            renderTopToolbarCustomActions={() => (<Rubrik>Varor</Rubrik>)}

                            muiTablePaperProps={{ elevation: 0, sx: { borderRadius: '0', border: '0px dashed #e0e0e0' } }}
                            muiTableBodyRowProps={({ row }) => ({
                                onClick: (event) => { editProductHandler(event, row); }, sx: { cursor: 'pointer' },
                            })}
                        />

                        <div className="product-actions">
                            <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} onClick={addProductHandler}>Lägg till vara </Button>
                            <Button className="QmeButton QmeButton--secondary" variant="outline-secondary" onClick={() => navigate("/productgroups")}> Se varugrupper </Button>
                        </div>
                    </Sida>
                </Container>
            </ContentWrapper>
        );
    } else {
        return (<Loading />);
    }
}

export function ModalProductEdit(props) {
    const { loading, data, Refresh, resultVariant, resultVisible, resultText, resultSuccess, ReInit, Update, XCall, GUIDx } = useBackend('');
    
    const productDefaultValues = { Guid: "00000000-0000-0000-0000-000000000000", Name: "Ny vara", "Description": "", "EAN": "", "Price": 0.00, "Vat": 6, "State": 1, "AllowManualRegistration": true, "ShowOnPricelist": true, "ProductGroup": { "Name": "", "Guid": "00000000-0000-0000-0000-000000000000"}, "ProductVariants": [] };

    const [Product, setProduct] = useState(productDefaultValues);        

    useEffect(
        () => {
            if (props.editProductGuid !== null && props.editProductGuid !== "00000000-0000-0000-0000-000000000000") {
                try {                
                    setProduct(data.Product);
                    console.log(data.Product);
                } catch {
                    setProduct(productDefaultValues);
                };                                
            }            
        }, [data]
    );
        
    async function closeForm() {
        setProduct(productDefaultValues);
        props.onHide();        
    }
    
    async function showForm() {
        if (props.editProductGuid !== null && props.editProductGuid !== "00000000-0000-0000-0000-000000000000") {
            await ReInit('/api/admin/product/' + props.editProductGuid);
        } 
    }

    var typingTimeout = null;

    async function handleSave() {
        const ProductForm = document.getElementById('ProductForm');
        const formData = new FormData(ProductForm);
        const formDataObj = Object.fromEntries(formData.entries());

        formDataObj.ShowOnPricelist = formData.has('ShowOnPricelist') ? true : false;
        formDataObj.AllowManualRegistration = formData.has('AllowManualRegistration') ? true : false;

        if (props.editProductGuid === "00000000-0000-0000-0000-000000000000") {
            let { errorsException } = await XCall('/api/admin/products', 'POST', 3000, formDataObj);
            if (!errorsException) {
                setTimeout(() => {
                    props.onHide();
                }, 2000);
            }
        } else {
            await XCall('/api/admin/product/' + props.editProductGuid, 'PATCH', 3000, formDataObj);
        }
    }

    async function handleRemove() {
        let { errorsException } = await XCall('/api/admin/product/' + Product.Guid, 'DELETE', 3000, {});
        if (!errorsException) props.onHide();
    }    

    async function handleGenerateEAN() {
        let { jsondata } = await XCall('/api/admin/GenerateEAN/', "PUT", 3000);
        document.getElementById("EAN").value = jsondata.EAN;
    }

    function handleChange(event) {
        if (props.editProductGuid !== "00000000-0000-0000-0000-000000000000") {
            clearTimeout(typingTimeout);
            typingTimeout = setTimeout(handleSave, 475);
        }
    }    

    function getOptions(object) {
        return object.map((key) => {
            return <option key={key.Guid} value={key.Guid}>{key.Name}</option>;
        });
    }    

    async function handleRemoveEAN(EANGuid) {
        await XCall('/api/admin/Product/' + props.editProductGuid + '/EAN/' + EANGuid, 'DELETE', 3000, {});
        await ReInit('/api/admin/product/' + props.editProductGuid);
    }

    function delay(time) {
        return new Promise(resolve => setTimeout(resolve, time));
    }

    async function handleAddEAN() {
        const VariantEAN = document.getElementById('VariantEAN').value;
        const VariantDescription = document.getElementById('VariantDescription').value;
        const formDataObj = { EAN: VariantEAN, Description: VariantDescription };        
        let { errorsException } = await XCall('/api/admin/Product/' + props.editProductGuid + '/EAN/', 'POST', 3000, formDataObj);
        
        if (!errorsException) {
            document.getElementById('VariantEAN').value = "";
            document.getElementById('VariantDescription').value = "";
            await ReInit('/api/admin/product/' + props.editProductGuid);
        }
    }

    async function handleGeneratePriceTag() {
        window.open("/api/Report/pricetag/" + props.editProductGuid, "_blank")
    }    
          
    return (
        <Modal show={props.show} onHide={() => closeForm()} onShow={() => showForm()} >
            
            <Modal.Header closeButton>
                {/* {Product.Guid === "00000000-0000-0000-0000-000000000000" ? (<Modal.Title>Ny vara</Modal.Title>) : (<Modal.Title>{Product.Name}</Modal.Title>)} */}
                <Modal.Title>{Product.Name}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={handleSave} id="ProductForm">

                    {Product.Guid === props.editProductGuid  && <>
                    <Form.Group className="mb-3" >
                        <Form.Label>Namn</Form.Label>
                        <Form.Control type="text" name="Name" placeholder="Produktnamn" defaultValue={Product.Name} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Produktbeskrivning</Form.Label>
                        <Form.Control type="text" name="Description" placeholder="Produktbeskrivning" defaultValue={Product.Description} onChange={handleChange} />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>EAN (Streckkoder)</Form.Label>

                        {Product.Guid === "00000000-0000-0000-0000-000000000000" ? (
                            <div className="d-flex">
                                <Form.Control type="text" id="EAN" name="EAN" placeholder="EAN" defaultValue={Product.EAN} onChange={handleChange} />&nbsp;
                                <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={handleGenerateEAN} disabled={Product.Guid === "00000000-0000-0000-0000-000000000000" ? (false) : (true)}>Generera</Button>
                            </div>
                        ) : (
                            <div>
                                <Table responsive="sm">
                                    <tbody>
                                        {Product.ProductVariants.map((variant) => {
                                            return <tr key={variant.Guid}>
                                                <td>{variant.EAN}</td>
                                                <td>{variant.Description}</td>
                                                <td><span className='sub' onClick={() => handleRemoveEAN(variant.Guid)}><FaTrash /></span></td>
                                            </tr>;
                                        })}
                                    </tbody>
                                </Table>

                                <div className="d-flex">
                                    <Form.Control type="text" id="VariantEAN" name="VariantEAN" placeholder="EAN/Streckkod" />&nbsp;
                                    <Form.Control type="text" id="VariantDescription" name="VariantDescription" placeholder="Färg/Smak/Storlek" />&nbsp;
                                    <Button className="QmeButton" variant="primary" type="button" onClick={() => handleAddEAN()} style={{ whiteSpace: "nowrap", minWidth: "auto", backgroundColor: Branding().ButtonColor }}>Lägg till</Button>
                                </div>
                            </div>
                        )}
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Produktgrupp</Form.Label>
                        <Form.Select name="ProductGroupGuid" defaultValue={Product.ProductGroup.Guid} onChange={handleChange}>
                            <option value={"00000000-0000-0000-0000-000000000000"}>------</option>
                            {getOptions(props.registerData.productGroups)}
                        </Form.Select>
                    </Form.Group>


                    <Form.Group className="mb-3" >
                        <Form.Label>Pris inkl. moms</Form.Label>
                        <Form.Control name="Price" placeholder="Produktpris" defaultValue={Product.Price.toFixed(2)} onChange={handleChange}                                     
                            type="number"
                            step="0.02" 
                            inputMode="decimal"
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Label>Momssats</Form.Label>
                        <Form.Select name="Vat" defaultValue={Product.Vat} onChange={handleChange}>
                            <option value="6">6% Tidningar, böcker, taxi, buss, flyg, tåg i Sverige</option>
                            <option value="12">12%  Livsmedel, restaurangbesök, hotell, konstverk</option>
                            <option value="25">25% Standard</option>
                        </Form.Select>
                    </Form.Group>
                    

                    <Form.Group className="mb-3" >
                        <Form.Check
                            type="switch"
                            name="ShowOnPricelist"
                            id="ShowOnPricelist"
                            label="Visa på prislista"
                            defaultChecked={Product.ShowOnPricelist}
                            onChange={handleChange}
                        />
                    </Form.Group>

                    <Form.Group className="mb-3" >
                        <Form.Check
                            type="switch"
                            name="AllowManualRegistration"
                            id="AllowManualRegistration"
                            label="Tillåt manuell registrering av varan i app"
                            defaultChecked={Product.AllowManualRegistration}
                            onChange={handleChange}
                        />
                    </Form.Group>
                    </>}

                    <Form.Group className="mb-3" hidden={!loading}>
                        <SpinnerX />
                    </Form.Group>

                    <Form.Group className="mb-3" hidden={!resultVisible}>
                        <Alert show={resultVisible} variant={resultVariant} className="FormSpace">{resultText}</Alert>
                    </Form.Group>
                </Form>

            </Modal.Body>
            <Modal.Footer>
                {Product.Guid === "00000000-0000-0000-0000-000000000000" ? (
                    <>
                        <Button className="QmeButton" style={{ backgroundColor: Branding().ButtonColor }} variant="primary" type="button" onClick={handleSave}>Lägg till varan</Button>
                        {/* <Button variant="danger" onClick={() => props.onHide()}>Avbryt</Button> */}
                    </>
                ) : (
                    <>
                        <Button variant="danger" type="button" onClick={handleRemove}>Ta bort varan</Button>
                        {/* <Button variant="secondary" onClick={() => props.onHide()}>Stäng</Button> */}
                    </>
                )}
            </Modal.Footer>
        </Modal>            
    )
}